import React, { Component } from "react";
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import "./../../View.css";
import "./../../Grid.css";
import "./../../Form.css";
import "./../../App.css";
import { ViewContainer } from "./../../View.jsx";
import SearchView from "../../widgets/SearchView";
import ProviderDocumentSearchForm from './ProviderDocumentSearchForm';
import ViewUtils from '../../ViewUtils';

const headCells = [
    { id: 'ProviderLegalName', numeric: false, disablePadding: true, label: 'Provider Legal Name' },
    { id: "ProviderTradeName", numeric: false, disablePadding: true, label: "Provider Trade Name" },
    { id: "ProviderSDLNumber", numeric: false, disablePadding: true, label: "Provider SDL Number" },
]

const searchParameters = [
    //{ Name: "DocumentType", Value: "" },
    //{ Name: "PrintType", Value: "" },
    //{ Name: "AccreditationStatus", Value: "" },
    { Name: "ProviderID", Value: "" },
]

const utils = new ViewUtils();
const toolbarRef = React.createRef();
const searchFormRef = React.createRef();

class ProviderDocuments extends Component {

    constructor(props) {
        super(props)
        this.state = {
            model: {
                //DocumentType: null,
                //PrintTypeID: null,
                //AccreditationStatus: null,
                ProviderID: null
            },
            selectedProviders: null,
            keyUpSwitch: false,
            clearGrid: false,
            documentsGenerated: false,
            messsageAlert: null,
            messageStyle: null
        }

        this.toolbarConfig = {
            items: [
                {
                    type: "buttonGroup",
                    buttons: [
                        {id: 'generate', label: 'Generate', icon: 'CreateIcon', tooltip: 'Generate letters / certificates',disabled: utils.isNull(this.state.selectedProviders)}
                    ]
                }
            ]
        };
    }

    handleToolbarButtonClick = (buttonId) => {
        if ("generate" === buttonId) {
            this.generateDocuments();
            toolbarRef.current.setButtonDisabled("generate", true);
        }
    }

    FileDownload = (documentName) => {

        utils.invokeUrl("api/sims/providerletters/DownloadProviderLetters?FileName=" + documentName, (response) => {

            var blob = new Blob([this.base64ToArrayBuffer(response.Base64)], { type: response.Type });
            var url = URL.createObjectURL(blob);

            const link = document.createElement('a');
            link.href = url;
            link.download = response.Name;
            link.target = '_blank';
            link.click();
            toolbarRef.current.setButtonDisabled("download", true);
        }, (e) => {
            this.setState({ messsageAlert: utils.SYSTEM_ERROR_MESSAGE, messageStyle: "outlinedError" });
        }
        );

    };

    generateDocuments = () => {
        const ProviderIDs = this.state.selectedProviders.map(e => e.Id);
        let data = {
            ProviderIDs: ProviderIDs,
            ...this.state.model
        }
        let url = "api/sims/providerletters/GenerateProviderLetters";
        utils.invokeUrl(url, (response) => {
            utils.showMessage(this, response.Message, response.MessageType);
            let documentInfo = JSON.parse(response.Message);
            this.FileDownload(documentInfo.OriginalFileName);
            toolbarRef.current.setButtonDisabled("download", !this.state.documentGenerated);
        },
            null,
            {
                method: 'PUT',
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json',
                    'Authorization': "Bearer " + localStorage.getItem("token")
                },
                body: JSON.stringify(data)
            }
        )
    };

    base64ToArrayBuffer(base64) {
        var binary_string = window.atob(base64);
        var len = binary_string.length;
        var bytes = new Uint8Array(len);
        for (var i = 0; i < len; i++) {
            bytes[i] = binary_string.charCodeAt(i);
        }
        return bytes.buffer;
    };

    onkeyup(e) {
        if (e.charCode == 13) {
            this.setState({ keyUpSwitch: !this.state.keyUpSwitch })
        }
    }

    handleSelectionChange = (selection) => {
        if (selection !== null && selection.length !== 0) {
            this.setState({ selectedProviders: selection, Message: "" },
                () => {
                    toolbarRef.current.setButtonDisabled("generate", selection.length === 0);
                }
            )
        } else {
            this.setState({ selectedProviders: null, Message: "" },
                () => {
                    toolbarRef.current.setButtonDisabled("generate", selection.length === 0);
                }
            )
        }
    }

    closePrompt = () => {
        this.setState({ propmtOpen: false })
    }

    handleFormValueChange = (values) => {
        let newValues = null;
        if (!utils.isNull(values)) {
            newValues = { ...values };
        }
        if (!utils.isNull(newValues)) {
            if (JSON.stringify(this.state.model) !== JSON.stringify(newValues)) {
                this.setState({
                    model: newValues,
                    clearGrid: true,
                    selectedAssessors: null,
                    Message: ""
                });
                toolbarRef.current.setButtonDisabled("generate", true);
            }
        }
    }

    onSearchRequiredFieldCheck = () => {
        if (searchFormRef.current.getValue()) {
            return true;
        }
        else {
            return false;
        }
    }

    onGridCleared = () => {
        this.setState({ clearGrid: false });
    }

    render() {
        return (
            <ViewContainer mode={this.props.mode} title="">
                <SearchView
                    headCells={headCells}
                    dataUrl="api/sims/providerletters/getsearch"
                    model={this.state.model}
                    searchLabel="SEARCH"
                    toolbarConfig={this.toolbarConfig}
                    searchParameters={searchParameters}
                    mode={this.props.mode}
                    multiSelect={true}
                    onLookupValueChange={this.props.onLookupValueChange}
                    history={this.props.history}
                    buttonClickHandler={this.handleToolbarButtonClick}
                    keyUpSwitch={this.state.keyUpSwitch}
                    setSelection={(selection) => { this.handleSelectionChange(selection) }}
                    autoFetchData={false}
                    toolbarRef={toolbarRef}
                    onSearchRequiredFieldCheck={this.onSearchRequiredFieldCheck}
                    clearGrid={this.state.clearGrid}
                    onGridCleared={this.onGridCleared}
                    title={"Provider Documents"}
                >
                    <ProviderDocumentSearchForm
                        ref={searchFormRef}
                        data={this.state.model}
                        onKeyUp={(e) => { this.onkeyup(e) }}
                        model={this.state.model}
                        valueChangeHandler={this.handleFormValueChange}
                        //dependency={this.state.dependency}
                    />
                </SearchView>
            </ViewContainer>
        );
    }
}

export default withRouter(
    connect()(ProviderDocuments)
);